import { IconButton, Stack, TextField, Tooltip, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { BinIcon, PlusIcon } from '@tom-ui/ui'
import { notAllowPlusMinusPointSign, onlyAllowPositiveInt } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { BerthFormStore } from '../../stores/nodes/berth.form-store'

interface Props {
  formStore: BerthFormStore
}
export const BerthBollardsForm = observer(({ formStore }: Props) => {
  const { t } = useTranslate()

  return (
    <Stack gap={2}>
      <Stack flexDirection='row' gap={1} alignItems='center'>
        <Typography variant='subtitle2'>{t('Bollards', 'Bollards')}</Typography>
        <Tooltip title={t('Add a bollard', 'Add a bollard')}>
          <IconButton onClick={() => formStore.addBollard()}>
            <PlusIcon />
          </IconButton>
        </Tooltip>
      </Stack>

      {formStore.bollards.value.map((bollard, index) => (
        <Stack key={`bollards_${index}`} flexDirection='row' gap={2} alignItems='center'>
          <Stack width='100%'>
            <TextField
              {...bollard.name.props}
              fullWidth
              label={t('name', 'Name')}
              required
              name='name'
            />
            {bollard.name.error && (
              <Typography variant='caption' color='error'>
                {t(bollard.name.error)}
              </Typography>
            )}
          </Stack>

          <Stack width='100%'>
            <TextField
              {...bollard.meterMark.props}
              fullWidth
              label={t('meterMark', 'Meter mark')}
              required
              type='number'
              onKeyDown={notAllowPlusMinusPointSign}
              onChange={e => {
                onlyAllowPositiveInt(e)
                bollard.meterMark.onChange(e)
              }}
            />
            {bollard.meterMark.error && (
              <Typography variant='caption' color='error'>
                {t(bollard.meterMark.error)}
              </Typography>
            )}
          </Stack>

          <IconButton
            sx={{ mt: 2, pointerEvents: 'all' }}
            color='error'
            onClick={() => formStore.deleteBollard(index)}
          >
            <Tooltip title={t('Remove bollard', 'Remove bollard')}>
              <BinIcon />
            </Tooltip>
          </IconButton>
        </Stack>
      ))}

      {!formStore.bollards.data.length && (
        <Typography variant='body2'>
          {t('No bollards to display', 'No bollards to display')}
        </Typography>
      )}
    </Stack>
  )
})
